import * as Sentry from "@sentry/nuxt"

export default (error: unknown) => Sentry.captureException(error)